import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { HttpApi } from '../httpApi';
import { IFilterStation, IStation } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  public apiKey = 'd953408f252b456d813b2fcfe77dcb71';
  private url = '';
  private filters: Array<IFilterStation> = [];
  constructor(private httpClient: HttpClient) { }
  get() {
    return this.httpClient.get(
      `https://newsapi.org/v2/top-headlines?sources=techcrunch&apiKey=${this.apiKey}`
    );
  }
  public setApi(url: string) {
    this.url = url;
  }
  public getAttribute(idAttribute: Number): IFilterStation {
    return this.filters.find(filter => filter.id === idAttribute);
  }
  public chageFilters(): Observable<Array<IFilterStation>> {
    const url = `${this.url}/${HttpApi.filters}`;
    return this.httpClient.get<Array<IFilterStation>>(url).pipe(tap(res => {
      this.filters = res;
    }));
  }
  public chageStations(): Observable<Array<IStation>> {
    const url = `${this.url}/${HttpApi.stations}`;
    return this.httpClient.get<Array<IStation>>(url).pipe(map(res => {
      return res.map( (data: any) => {
        const attributes = (data.filtros as Array<any>).map(filter => {
          return Number(filter.filtro);
        });
        return {
          ...data,
          latitude: Number(data.latitud),
          longitude: Number(data.longitud),
          attributes
        };
      })
      
    }));
  }
}
